import { RFQ_QuoteTablePage } from "@b2b/ui-components/features/RFQ_QuoteTable";

export default function RFQ_QuoteTable() {
    return <RFQ_QuoteTablePage />;
}